<div id="auth">
  <div class="panel panel-centered">
    <h1 class="page-title">Login</h1>
    <auth-login
      (loginSuccess)="onLoginSuccess($event)"
      [errorHandlingMap]="errorHandlingMap()"
      [additionalLoginErrors]="additionalLoginErrors()"
      [isLoading]="isLoading()"
    >
      <div class="login-account-cta">
        <a id="forgot-password" class="color-gray-md" ng-ui-sref="forgotPassword">Forgot password</a>
        <a id="reset-password" class="color-gray-md" ng-ui-sref="resetPassword">Have a code?</a>
      </div>
    </auth-login>
  </div>
</div>
